import { render, staticRenderFns } from "./attachment.vue?vue&type=template&id=733a396a&scoped=true&"
import script from "./attachment.vue?vue&type=script&lang=js&"
export * from "./attachment.vue?vue&type=script&lang=js&"
import style0 from "./attachment.vue?vue&type=style&index=0&id=733a396a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733a396a",
  null
  
)

export default component.exports